import { reactive, ref } from "vue";

export function useSyuugyouBasyoModal() {
  const SyuugyouBasyoModalRef = ref()

  const SyuugyouBasyoModalParts = reactive({
    title: '就業場所の選択',
    button: ''
  })

  const openSyuugyouBasyoModal = () => {
    SyuugyouBasyoModalRef.value.open()
  }

  const closeSyuugyouBasyoModal = () => {
    SyuugyouBasyoModalRef.value.close()
  }

  return {
    SyuugyouBasyoModalRef,
    SyuugyouBasyoModalParts,
    openSyuugyouBasyoModal,
    closeSyuugyouBasyoModal,
  }
}
